import User from '../models/user'
import { fetchFromBackend } from '../common/backend-client'

export async function queryHasOttersPermission() {
  patchAuthHeader()
  return await fetchFromBackend('accounts/queries/has-otters-permission')
}

function patchAuthHeader() {
  $(document).ajaxSend((e, xhr) => {
    const authKey = User.authKey
    if (authKey) {
      xhr.setRequestHeader('Authorization', `Token ${authKey}`)
    }
  })
}
